import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../../routing/services/routing.service';
import { EventsService } from '../../../events/services/events.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['../../scss/dashboard.components.scss']
})

export class AppDashboardComponent implements OnInit {
    constructor(private routingService: RoutingService, private eventService: EventsService) {
    }

    ngOnInit(){
      this.eventService.recordDashboardLoadedEvent();
    }
 }



// WEBPACK FOOTER //
// ./src/app/dashboard/components/dashboard/dashboard.component.ts